/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BatchEligibilityHistoryQueryModel } from '../models';
// @ts-ignore
import type { BatchEligibilityResubmitCreateModel } from '../models';
// @ts-ignore
import type { BatchEligibilityResubmitQueryModel } from '../models';
// @ts-ignore
import type { BatchExportRequestParams } from '../models';
// @ts-ignore
import type { BatchTransactionResponseModel } from '../models';
// @ts-ignore
import type { BatchUploadEligibilityModel } from '../models';
// @ts-ignore
import type { BatchUploadEligibilityPatchModel } from '../models';
// @ts-ignore
import type { ClaimStatusRequest } from '../models';
// @ts-ignore
import type { ClaimStatusRequestQueryModel } from '../models';
// @ts-ignore
import type { ClaimStatusResponse } from '../models';
// @ts-ignore
import type { EligibilityRequest } from '../models';
// @ts-ignore
import type { EligibilityRequestQueryModel } from '../models';
// @ts-ignore
import type { EligibilityResponse } from '../models';
// @ts-ignore
import type { EligibilityResponseList } from '../models';
// @ts-ignore
import type { GetBatchEligibilityRequest200Response } from '../models';
// @ts-ignore
import type { GetBatchEligibilityRequests200Response } from '../models';
// @ts-ignore
import type { GetClaimStatusRequests200Response } from '../models';
// @ts-ignore
import type { GetEligibilityRequests200Response } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PaginatedResubmitEligibilityResponseList } from '../models';
// @ts-ignore
import type { PatchBatchUploadResponseModel } from '../models';
// @ts-ignore
import type { PostBatchUploadResponseModel } from '../models';
/**
 * EzapiApi - axios parameter creator
 * @export
 */
export const EzapiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} batchId 
         * @param {string} reason 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBatchEligibilityRequest: async (batchId: string, reason: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('cancelBatchEligibilityRequest', 'batchId', batchId)
            // verify required parameter 'reason' is not null or undefined
            assertParamExists('cancelBatchEligibilityRequest', 'reason', reason)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/status/{batchId}`
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} batchId 
         * @param {BatchExportRequestParams} batchExportRequestParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBatchEligibilityRequests: async (batchId: string, batchExportRequestParams: BatchExportRequestParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('downloadBatchEligibilityRequests', 'batchId', batchId)
            // verify required parameter 'batchExportRequestParams' is not null or undefined
            assertParamExists('downloadBatchEligibilityRequests', 'batchExportRequestParams', batchExportRequestParams)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/history/{batchId}/export`
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchExportRequestParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to export the exiting claim status request data between start date and end date in .xslx format
         * @summary export existing claim status request data
         * @param {ClaimStatusRequestQueryModel} claimStatusRequestQueryModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportClaimStatusRequest: async (claimStatusRequestQueryModel: ClaimStatusRequestQueryModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimStatusRequestQueryModel' is not null or undefined
            assertParamExists('exportClaimStatusRequest', 'claimStatusRequestQueryModel', claimStatusRequestQueryModel)
            const localVarPath = `/api/v1/ezapi/claimStatus/responses/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimStatusRequestQueryModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to export the exiting eligibility request data between start date and end date in .xslx format
         * @summary export existing eligibilityrequest data
         * @param {EligibilityRequestQueryModel} eligibilityRequestQueryModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEligibilityRequest: async (eligibilityRequestQueryModel: EligibilityRequestQueryModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eligibilityRequestQueryModel' is not null or undefined
            assertParamExists('exportEligibilityRequest', 'eligibilityRequestQueryModel', eligibilityRequestQueryModel)
            const localVarPath = `/api/v1/ezapi/eligibility/responses/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eligibilityRequestQueryModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} batchId 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchEligibilityRequest: async (batchId: string, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('getBatchEligibilityRequest', 'batchId', batchId)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/history/{batchId}`
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BatchEligibilityHistoryQueryModel} batchEligibilityHistoryQueryModel 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchEligibilityRequests: async (batchEligibilityHistoryQueryModel: BatchEligibilityHistoryQueryModel, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchEligibilityHistoryQueryModel' is not null or undefined
            assertParamExists('getBatchEligibilityRequests', 'batchEligibilityHistoryQueryModel', batchEligibilityHistoryQueryModel)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchEligibilityHistoryQueryModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchHeaderMapping: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getBatchHeaderMapping', 'requestBody', requestBody)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/upload/headerMapping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} batchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchUploadEligibilityRequest: async (batchId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('getBatchUploadEligibilityRequest', 'batchId', batchId)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/upload/{batchId}`
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchUploadEligibilityRequestTemplate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ezapi/batch/eligibility/upload/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns paginated data for claim status requests
         * @summary Get paginated data for Claim status requests
         * @param {ClaimStatusRequestQueryModel} claimStatusRequestQueryModel 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimStatusRequests: async (claimStatusRequestQueryModel: ClaimStatusRequestQueryModel, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimStatusRequestQueryModel' is not null or undefined
            assertParamExists('getClaimStatusRequests', 'claimStatusRequestQueryModel', claimStatusRequestQueryModel)
            const localVarPath = `/api/v1/ezapi/claimStatus/responses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimStatusRequestQueryModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to get the claimstatus request reponse and data
         * @summary Get data for Claim Status Response given ID
         * @param {string} responseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimStatusResponseByID: async (responseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'responseId' is not null or undefined
            assertParamExists('getClaimStatusResponseByID', 'responseId', responseId)
            const localVarPath = `/api/v1/ezapi/claimStatus/responses/{response_id}`
                .replace(`{${"response_id"}}`, encodeURIComponent(String(responseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get eligibility request data
         * @summary Get paginated data for a Eligibility Requests
         * @param {EligibilityRequestQueryModel} eligibilityRequestQueryModel 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEligibilityRequests: async (eligibilityRequestQueryModel: EligibilityRequestQueryModel, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eligibilityRequestQueryModel' is not null or undefined
            assertParamExists('getEligibilityRequests', 'eligibilityRequestQueryModel', eligibilityRequestQueryModel)
            const localVarPath = `/api/v1/ezapi/eligibility/responses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eligibilityRequestQueryModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to get the eligibility request status and data
         * @summary Get data for a Eligibility request
         * @param {string} responseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEligibilityResponseByID: async (responseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'responseId' is not null or undefined
            assertParamExists('getEligibilityResponseByID', 'responseId', responseId)
            const localVarPath = `/api/v1/ezapi/eligibility/responses/{response_id}`
                .replace(`{${"response_id"}}`, encodeURIComponent(String(responseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} batchId 
         * @param {BatchUploadEligibilityPatchModel} batchUploadEligibilityPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBatchUploadEligibilityRequest: async (batchId: string, batchUploadEligibilityPatchModel: BatchUploadEligibilityPatchModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('patchBatchUploadEligibilityRequest', 'batchId', batchId)
            // verify required parameter 'batchUploadEligibilityPatchModel' is not null or undefined
            assertParamExists('patchBatchUploadEligibilityRequest', 'batchUploadEligibilityPatchModel', batchUploadEligibilityPatchModel)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/upload/{batchId}`
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchUploadEligibilityPatchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} batchId 
         * @param {{ [key: string]: string; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBatchUploadEligibilityRequestMapping: async (batchId: string, requestBody: { [key: string]: string; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('patchBatchUploadEligibilityRequestMapping', 'batchId', batchId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('patchBatchUploadEligibilityRequestMapping', 'requestBody', requestBody)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/upload/{batchId}/mapping`
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BatchEligibilityResubmitCreateModel} batchEligibilityResubmitCreateModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBatchResubmitEligibilityRequest: async (batchEligibilityResubmitCreateModel: BatchEligibilityResubmitCreateModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchEligibilityResubmitCreateModel' is not null or undefined
            assertParamExists('postBatchResubmitEligibilityRequest', 'batchEligibilityResubmitCreateModel', batchEligibilityResubmitCreateModel)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/resubmit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchEligibilityResubmitCreateModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} file 
         * @param {BatchUploadEligibilityModel} uploadModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBatchUploadEligibilityRequest: async (file: File, uploadModel: BatchUploadEligibilityModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('postBatchUploadEligibilityRequest', 'file', file)
            // verify required parameter 'uploadModel' is not null or undefined
            assertParamExists('postBatchUploadEligibilityRequest', 'uploadModel', uploadModel)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (uploadModel !== undefined) { 
                localVarFormParams.append('uploadModel', new Blob([JSON.stringify(uploadModel)], { type: "application/json", }));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get patient info - check in insurancecoverage if payer, beneficiary, memberId relation exists if it exists then validate data, update patient record and make claim status check request else validate data, create patient record, create insurancecoverage record and make claim status check request
         * @summary post claim status requests
         * @param {Array<ClaimStatusRequest>} claimStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postClaimStatusRequests: async (claimStatusRequest: Array<ClaimStatusRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimStatusRequest' is not null or undefined
            assertParamExists('postClaimStatusRequests', 'claimStatusRequest', claimStatusRequest)
            const localVarPath = `/api/v1/ezapi/claimStatus/requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get patient info - check in insurancecoverage if payer, beneficiary, memberId relation exists if it exists:     validate data, update patient record and make eligibility request else:     validate data, create patient record, create insurancecoverage record and make eligibility request
         * @summary post eligibility requests
         * @param {Array<EligibilityRequest>} eligibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEligibilityRequests: async (eligibilityRequest: Array<EligibilityRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eligibilityRequest' is not null or undefined
            assertParamExists('postEligibilityRequests', 'eligibilityRequest', eligibilityRequest)
            const localVarPath = `/api/v1/ezapi/eligibility/requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eligibilityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BatchEligibilityResubmitQueryModel} batchEligibilityResubmitQueryModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBatchResubmitEligibilityRequest: async (batchEligibilityResubmitQueryModel: BatchEligibilityResubmitQueryModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchEligibilityResubmitQueryModel' is not null or undefined
            assertParamExists('validateBatchResubmitEligibilityRequest', 'batchEligibilityResubmitQueryModel', batchEligibilityResubmitQueryModel)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/resubmit/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchEligibilityResubmitQueryModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} batchId 
         * @param {BatchUploadEligibilityPatchModel} batchUploadEligibilityPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePatchBatchUploadEligibilityRequest: async (batchId: string, batchUploadEligibilityPatchModel: BatchUploadEligibilityPatchModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('validatePatchBatchUploadEligibilityRequest', 'batchId', batchId)
            // verify required parameter 'batchUploadEligibilityPatchModel' is not null or undefined
            assertParamExists('validatePatchBatchUploadEligibilityRequest', 'batchUploadEligibilityPatchModel', batchUploadEligibilityPatchModel)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/upload/{batchId}/validate`
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchUploadEligibilityPatchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EzapiApi - functional programming interface
 * @export
 */
export const EzapiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EzapiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} batchId 
         * @param {string} reason 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelBatchEligibilityRequest(batchId: string, reason: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelBatchEligibilityRequest(batchId, reason, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.cancelBatchEligibilityRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} batchId 
         * @param {BatchExportRequestParams} batchExportRequestParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadBatchEligibilityRequests(batchId: string, batchExportRequestParams: BatchExportRequestParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadBatchEligibilityRequests(batchId, batchExportRequestParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.downloadBatchEligibilityRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to export the exiting claim status request data between start date and end date in .xslx format
         * @summary export existing claim status request data
         * @param {ClaimStatusRequestQueryModel} claimStatusRequestQueryModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportClaimStatusRequest(claimStatusRequestQueryModel: ClaimStatusRequestQueryModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportClaimStatusRequest(claimStatusRequestQueryModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.exportClaimStatusRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to export the exiting eligibility request data between start date and end date in .xslx format
         * @summary export existing eligibilityrequest data
         * @param {EligibilityRequestQueryModel} eligibilityRequestQueryModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportEligibilityRequest(eligibilityRequestQueryModel: EligibilityRequestQueryModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportEligibilityRequest(eligibilityRequestQueryModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.exportEligibilityRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} batchId 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBatchEligibilityRequest(batchId: string, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBatchEligibilityRequest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBatchEligibilityRequest(batchId, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.getBatchEligibilityRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BatchEligibilityHistoryQueryModel} batchEligibilityHistoryQueryModel 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBatchEligibilityRequests(batchEligibilityHistoryQueryModel: BatchEligibilityHistoryQueryModel, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBatchEligibilityRequests200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBatchEligibilityRequests(batchEligibilityHistoryQueryModel, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.getBatchEligibilityRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBatchHeaderMapping(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBatchHeaderMapping(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.getBatchHeaderMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} batchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBatchUploadEligibilityRequest(batchId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatchBatchUploadResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBatchUploadEligibilityRequest(batchId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.getBatchUploadEligibilityRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBatchUploadEligibilityRequestTemplate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBatchUploadEligibilityRequestTemplate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.getBatchUploadEligibilityRequestTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * returns paginated data for claim status requests
         * @summary Get paginated data for Claim status requests
         * @param {ClaimStatusRequestQueryModel} claimStatusRequestQueryModel 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClaimStatusRequests(claimStatusRequestQueryModel: ClaimStatusRequestQueryModel, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClaimStatusRequests200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClaimStatusRequests(claimStatusRequestQueryModel, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.getClaimStatusRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to get the claimstatus request reponse and data
         * @summary Get data for Claim Status Response given ID
         * @param {string} responseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClaimStatusResponseByID(responseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClaimStatusResponseByID(responseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.getClaimStatusResponseByID']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get eligibility request data
         * @summary Get paginated data for a Eligibility Requests
         * @param {EligibilityRequestQueryModel} eligibilityRequestQueryModel 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEligibilityRequests(eligibilityRequestQueryModel: EligibilityRequestQueryModel, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEligibilityRequests200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEligibilityRequests(eligibilityRequestQueryModel, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.getEligibilityRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to get the eligibility request status and data
         * @summary Get data for a Eligibility request
         * @param {string} responseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEligibilityResponseByID(responseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EligibilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEligibilityResponseByID(responseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.getEligibilityResponseByID']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} batchId 
         * @param {BatchUploadEligibilityPatchModel} batchUploadEligibilityPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchBatchUploadEligibilityRequest(batchId: string, batchUploadEligibilityPatchModel: BatchUploadEligibilityPatchModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatchBatchUploadResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchBatchUploadEligibilityRequest(batchId, batchUploadEligibilityPatchModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.patchBatchUploadEligibilityRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} batchId 
         * @param {{ [key: string]: string; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchBatchUploadEligibilityRequestMapping(batchId: string, requestBody: { [key: string]: string; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatchBatchUploadResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchBatchUploadEligibilityRequestMapping(batchId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.patchBatchUploadEligibilityRequestMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BatchEligibilityResubmitCreateModel} batchEligibilityResubmitCreateModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postBatchResubmitEligibilityRequest(batchEligibilityResubmitCreateModel: BatchEligibilityResubmitCreateModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchTransactionResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postBatchResubmitEligibilityRequest(batchEligibilityResubmitCreateModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.postBatchResubmitEligibilityRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} file 
         * @param {BatchUploadEligibilityModel} uploadModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postBatchUploadEligibilityRequest(file: File, uploadModel: BatchUploadEligibilityModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostBatchUploadResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postBatchUploadEligibilityRequest(file, uploadModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.postBatchUploadEligibilityRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get patient info - check in insurancecoverage if payer, beneficiary, memberId relation exists if it exists then validate data, update patient record and make claim status check request else validate data, create patient record, create insurancecoverage record and make claim status check request
         * @summary post claim status requests
         * @param {Array<ClaimStatusRequest>} claimStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postClaimStatusRequests(claimStatusRequest: Array<ClaimStatusRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClaimStatusResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postClaimStatusRequests(claimStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.postClaimStatusRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get patient info - check in insurancecoverage if payer, beneficiary, memberId relation exists if it exists:     validate data, update patient record and make eligibility request else:     validate data, create patient record, create insurancecoverage record and make eligibility request
         * @summary post eligibility requests
         * @param {Array<EligibilityRequest>} eligibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postEligibilityRequests(eligibilityRequest: Array<EligibilityRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EligibilityResponseList>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postEligibilityRequests(eligibilityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.postEligibilityRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BatchEligibilityResubmitQueryModel} batchEligibilityResubmitQueryModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateBatchResubmitEligibilityRequest(batchEligibilityResubmitQueryModel: BatchEligibilityResubmitQueryModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResubmitEligibilityResponseList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateBatchResubmitEligibilityRequest(batchEligibilityResubmitQueryModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.validateBatchResubmitEligibilityRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} batchId 
         * @param {BatchUploadEligibilityPatchModel} batchUploadEligibilityPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validatePatchBatchUploadEligibilityRequest(batchId: string, batchUploadEligibilityPatchModel: BatchUploadEligibilityPatchModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatchBatchUploadResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validatePatchBatchUploadEligibilityRequest(batchId, batchUploadEligibilityPatchModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.validatePatchBatchUploadEligibilityRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EzapiApi - factory interface
 * @export
 */
export const EzapiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EzapiApiFp(configuration)
    return {
        /**
         * 
         * @param {string} batchId 
         * @param {string} reason 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBatchEligibilityRequest(batchId: string, reason: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelBatchEligibilityRequest(batchId, reason, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} batchId 
         * @param {BatchExportRequestParams} batchExportRequestParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBatchEligibilityRequests(batchId: string, batchExportRequestParams: BatchExportRequestParams, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.downloadBatchEligibilityRequests(batchId, batchExportRequestParams, options).then((request) => request(axios, basePath));
        },
        /**
         * API to export the exiting claim status request data between start date and end date in .xslx format
         * @summary export existing claim status request data
         * @param {ClaimStatusRequestQueryModel} claimStatusRequestQueryModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportClaimStatusRequest(claimStatusRequestQueryModel: ClaimStatusRequestQueryModel, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.exportClaimStatusRequest(claimStatusRequestQueryModel, options).then((request) => request(axios, basePath));
        },
        /**
         * API to export the exiting eligibility request data between start date and end date in .xslx format
         * @summary export existing eligibilityrequest data
         * @param {EligibilityRequestQueryModel} eligibilityRequestQueryModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEligibilityRequest(eligibilityRequestQueryModel: EligibilityRequestQueryModel, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.exportEligibilityRequest(eligibilityRequestQueryModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} batchId 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchEligibilityRequest(batchId: string, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetBatchEligibilityRequest200Response> {
            return localVarFp.getBatchEligibilityRequest(batchId, pgNum, pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BatchEligibilityHistoryQueryModel} batchEligibilityHistoryQueryModel 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchEligibilityRequests(batchEligibilityHistoryQueryModel: BatchEligibilityHistoryQueryModel, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetBatchEligibilityRequests200Response> {
            return localVarFp.getBatchEligibilityRequests(batchEligibilityHistoryQueryModel, pgNum, pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchHeaderMapping(requestBody: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.getBatchHeaderMapping(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} batchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchUploadEligibilityRequest(batchId: string, options?: RawAxiosRequestConfig): AxiosPromise<PatchBatchUploadResponseModel> {
            return localVarFp.getBatchUploadEligibilityRequest(batchId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchUploadEligibilityRequestTemplate(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getBatchUploadEligibilityRequestTemplate(options).then((request) => request(axios, basePath));
        },
        /**
         * returns paginated data for claim status requests
         * @summary Get paginated data for Claim status requests
         * @param {ClaimStatusRequestQueryModel} claimStatusRequestQueryModel 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimStatusRequests(claimStatusRequestQueryModel: ClaimStatusRequestQueryModel, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetClaimStatusRequests200Response> {
            return localVarFp.getClaimStatusRequests(claimStatusRequestQueryModel, pgNum, pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * API to get the claimstatus request reponse and data
         * @summary Get data for Claim Status Response given ID
         * @param {string} responseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimStatusResponseByID(responseId: string, options?: RawAxiosRequestConfig): AxiosPromise<ClaimStatusResponse> {
            return localVarFp.getClaimStatusResponseByID(responseId, options).then((request) => request(axios, basePath));
        },
        /**
         * get eligibility request data
         * @summary Get paginated data for a Eligibility Requests
         * @param {EligibilityRequestQueryModel} eligibilityRequestQueryModel 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEligibilityRequests(eligibilityRequestQueryModel: EligibilityRequestQueryModel, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetEligibilityRequests200Response> {
            return localVarFp.getEligibilityRequests(eligibilityRequestQueryModel, pgNum, pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * API to get the eligibility request status and data
         * @summary Get data for a Eligibility request
         * @param {string} responseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEligibilityResponseByID(responseId: string, options?: RawAxiosRequestConfig): AxiosPromise<EligibilityResponse> {
            return localVarFp.getEligibilityResponseByID(responseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} batchId 
         * @param {BatchUploadEligibilityPatchModel} batchUploadEligibilityPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBatchUploadEligibilityRequest(batchId: string, batchUploadEligibilityPatchModel: BatchUploadEligibilityPatchModel, options?: RawAxiosRequestConfig): AxiosPromise<PatchBatchUploadResponseModel> {
            return localVarFp.patchBatchUploadEligibilityRequest(batchId, batchUploadEligibilityPatchModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} batchId 
         * @param {{ [key: string]: string; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBatchUploadEligibilityRequestMapping(batchId: string, requestBody: { [key: string]: string; }, options?: RawAxiosRequestConfig): AxiosPromise<PatchBatchUploadResponseModel> {
            return localVarFp.patchBatchUploadEligibilityRequestMapping(batchId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BatchEligibilityResubmitCreateModel} batchEligibilityResubmitCreateModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBatchResubmitEligibilityRequest(batchEligibilityResubmitCreateModel: BatchEligibilityResubmitCreateModel, options?: RawAxiosRequestConfig): AxiosPromise<BatchTransactionResponseModel> {
            return localVarFp.postBatchResubmitEligibilityRequest(batchEligibilityResubmitCreateModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {File} file 
         * @param {BatchUploadEligibilityModel} uploadModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBatchUploadEligibilityRequest(file: File, uploadModel: BatchUploadEligibilityModel, options?: RawAxiosRequestConfig): AxiosPromise<PostBatchUploadResponseModel> {
            return localVarFp.postBatchUploadEligibilityRequest(file, uploadModel, options).then((request) => request(axios, basePath));
        },
        /**
         * get patient info - check in insurancecoverage if payer, beneficiary, memberId relation exists if it exists then validate data, update patient record and make claim status check request else validate data, create patient record, create insurancecoverage record and make claim status check request
         * @summary post claim status requests
         * @param {Array<ClaimStatusRequest>} claimStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postClaimStatusRequests(claimStatusRequest: Array<ClaimStatusRequest>, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClaimStatusResponse>> {
            return localVarFp.postClaimStatusRequests(claimStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * get patient info - check in insurancecoverage if payer, beneficiary, memberId relation exists if it exists:     validate data, update patient record and make eligibility request else:     validate data, create patient record, create insurancecoverage record and make eligibility request
         * @summary post eligibility requests
         * @param {Array<EligibilityRequest>} eligibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEligibilityRequests(eligibilityRequest: Array<EligibilityRequest>, options?: RawAxiosRequestConfig): AxiosPromise<Array<EligibilityResponseList>> {
            return localVarFp.postEligibilityRequests(eligibilityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BatchEligibilityResubmitQueryModel} batchEligibilityResubmitQueryModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBatchResubmitEligibilityRequest(batchEligibilityResubmitQueryModel: BatchEligibilityResubmitQueryModel, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResubmitEligibilityResponseList> {
            return localVarFp.validateBatchResubmitEligibilityRequest(batchEligibilityResubmitQueryModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} batchId 
         * @param {BatchUploadEligibilityPatchModel} batchUploadEligibilityPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePatchBatchUploadEligibilityRequest(batchId: string, batchUploadEligibilityPatchModel: BatchUploadEligibilityPatchModel, options?: RawAxiosRequestConfig): AxiosPromise<PatchBatchUploadResponseModel> {
            return localVarFp.validatePatchBatchUploadEligibilityRequest(batchId, batchUploadEligibilityPatchModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EzapiApi - interface
 * @export
 * @interface EzapiApi
 */
export interface EzapiApiInterface {
    /**
     * 
     * @param {string} batchId 
     * @param {string} reason 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    cancelBatchEligibilityRequest(batchId: string, reason: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {string} batchId 
     * @param {BatchExportRequestParams} batchExportRequestParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    downloadBatchEligibilityRequests(batchId: string, batchExportRequestParams: BatchExportRequestParams, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

    /**
     * API to export the exiting claim status request data between start date and end date in .xslx format
     * @summary export existing claim status request data
     * @param {ClaimStatusRequestQueryModel} claimStatusRequestQueryModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    exportClaimStatusRequest(claimStatusRequestQueryModel: ClaimStatusRequestQueryModel, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * API to export the exiting eligibility request data between start date and end date in .xslx format
     * @summary export existing eligibilityrequest data
     * @param {EligibilityRequestQueryModel} eligibilityRequestQueryModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    exportEligibilityRequest(eligibilityRequestQueryModel: EligibilityRequestQueryModel, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @param {string} batchId 
     * @param {number} [pgNum] 
     * @param {number} [pgSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    getBatchEligibilityRequest(batchId: string, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetBatchEligibilityRequest200Response>;

    /**
     * 
     * @param {BatchEligibilityHistoryQueryModel} batchEligibilityHistoryQueryModel 
     * @param {number} [pgNum] 
     * @param {number} [pgSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    getBatchEligibilityRequests(batchEligibilityHistoryQueryModel: BatchEligibilityHistoryQueryModel, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetBatchEligibilityRequests200Response>;

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    getBatchHeaderMapping(requestBody: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }>;

    /**
     * 
     * @param {string} batchId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    getBatchUploadEligibilityRequest(batchId: string, options?: RawAxiosRequestConfig): AxiosPromise<PatchBatchUploadResponseModel>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    getBatchUploadEligibilityRequestTemplate(options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * returns paginated data for claim status requests
     * @summary Get paginated data for Claim status requests
     * @param {ClaimStatusRequestQueryModel} claimStatusRequestQueryModel 
     * @param {number} [pgNum] 
     * @param {number} [pgSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    getClaimStatusRequests(claimStatusRequestQueryModel: ClaimStatusRequestQueryModel, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetClaimStatusRequests200Response>;

    /**
     * API to get the claimstatus request reponse and data
     * @summary Get data for Claim Status Response given ID
     * @param {string} responseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    getClaimStatusResponseByID(responseId: string, options?: RawAxiosRequestConfig): AxiosPromise<ClaimStatusResponse>;

    /**
     * get eligibility request data
     * @summary Get paginated data for a Eligibility Requests
     * @param {EligibilityRequestQueryModel} eligibilityRequestQueryModel 
     * @param {number} [pgNum] 
     * @param {number} [pgSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    getEligibilityRequests(eligibilityRequestQueryModel: EligibilityRequestQueryModel, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetEligibilityRequests200Response>;

    /**
     * API to get the eligibility request status and data
     * @summary Get data for a Eligibility request
     * @param {string} responseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    getEligibilityResponseByID(responseId: string, options?: RawAxiosRequestConfig): AxiosPromise<EligibilityResponse>;

    /**
     * 
     * @param {string} batchId 
     * @param {BatchUploadEligibilityPatchModel} batchUploadEligibilityPatchModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    patchBatchUploadEligibilityRequest(batchId: string, batchUploadEligibilityPatchModel: BatchUploadEligibilityPatchModel, options?: RawAxiosRequestConfig): AxiosPromise<PatchBatchUploadResponseModel>;

    /**
     * 
     * @param {string} batchId 
     * @param {{ [key: string]: string; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    patchBatchUploadEligibilityRequestMapping(batchId: string, requestBody: { [key: string]: string; }, options?: RawAxiosRequestConfig): AxiosPromise<PatchBatchUploadResponseModel>;

    /**
     * 
     * @param {BatchEligibilityResubmitCreateModel} batchEligibilityResubmitCreateModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    postBatchResubmitEligibilityRequest(batchEligibilityResubmitCreateModel: BatchEligibilityResubmitCreateModel, options?: RawAxiosRequestConfig): AxiosPromise<BatchTransactionResponseModel>;

    /**
     * 
     * @param {File} file 
     * @param {BatchUploadEligibilityModel} uploadModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    postBatchUploadEligibilityRequest(file: File, uploadModel: BatchUploadEligibilityModel, options?: RawAxiosRequestConfig): AxiosPromise<PostBatchUploadResponseModel>;

    /**
     * get patient info - check in insurancecoverage if payer, beneficiary, memberId relation exists if it exists then validate data, update patient record and make claim status check request else validate data, create patient record, create insurancecoverage record and make claim status check request
     * @summary post claim status requests
     * @param {Array<ClaimStatusRequest>} claimStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    postClaimStatusRequests(claimStatusRequest: Array<ClaimStatusRequest>, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClaimStatusResponse>>;

    /**
     * get patient info - check in insurancecoverage if payer, beneficiary, memberId relation exists if it exists:     validate data, update patient record and make eligibility request else:     validate data, create patient record, create insurancecoverage record and make eligibility request
     * @summary post eligibility requests
     * @param {Array<EligibilityRequest>} eligibilityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    postEligibilityRequests(eligibilityRequest: Array<EligibilityRequest>, options?: RawAxiosRequestConfig): AxiosPromise<Array<EligibilityResponseList>>;

    /**
     * 
     * @param {BatchEligibilityResubmitQueryModel} batchEligibilityResubmitQueryModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    validateBatchResubmitEligibilityRequest(batchEligibilityResubmitQueryModel: BatchEligibilityResubmitQueryModel, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResubmitEligibilityResponseList>;

    /**
     * 
     * @param {string} batchId 
     * @param {BatchUploadEligibilityPatchModel} batchUploadEligibilityPatchModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    validatePatchBatchUploadEligibilityRequest(batchId: string, batchUploadEligibilityPatchModel: BatchUploadEligibilityPatchModel, options?: RawAxiosRequestConfig): AxiosPromise<PatchBatchUploadResponseModel>;

}

/**
 * EzapiApi - object-oriented interface
 * @export
 * @class EzapiApi
 * @extends {BaseAPI}
 */
export class EzapiApi extends BaseAPI implements EzapiApiInterface {
    /**
     * 
     * @param {string} batchId 
     * @param {string} reason 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public cancelBatchEligibilityRequest(batchId: string, reason: string, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).cancelBatchEligibilityRequest(batchId, reason, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} batchId 
     * @param {BatchExportRequestParams} batchExportRequestParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public downloadBatchEligibilityRequests(batchId: string, batchExportRequestParams: BatchExportRequestParams, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).downloadBatchEligibilityRequests(batchId, batchExportRequestParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to export the exiting claim status request data between start date and end date in .xslx format
     * @summary export existing claim status request data
     * @param {ClaimStatusRequestQueryModel} claimStatusRequestQueryModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public exportClaimStatusRequest(claimStatusRequestQueryModel: ClaimStatusRequestQueryModel, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).exportClaimStatusRequest(claimStatusRequestQueryModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to export the exiting eligibility request data between start date and end date in .xslx format
     * @summary export existing eligibilityrequest data
     * @param {EligibilityRequestQueryModel} eligibilityRequestQueryModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public exportEligibilityRequest(eligibilityRequestQueryModel: EligibilityRequestQueryModel, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).exportEligibilityRequest(eligibilityRequestQueryModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} batchId 
     * @param {number} [pgNum] 
     * @param {number} [pgSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public getBatchEligibilityRequest(batchId: string, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).getBatchEligibilityRequest(batchId, pgNum, pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BatchEligibilityHistoryQueryModel} batchEligibilityHistoryQueryModel 
     * @param {number} [pgNum] 
     * @param {number} [pgSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public getBatchEligibilityRequests(batchEligibilityHistoryQueryModel: BatchEligibilityHistoryQueryModel, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).getBatchEligibilityRequests(batchEligibilityHistoryQueryModel, pgNum, pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public getBatchHeaderMapping(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).getBatchHeaderMapping(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} batchId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public getBatchUploadEligibilityRequest(batchId: string, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).getBatchUploadEligibilityRequest(batchId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public getBatchUploadEligibilityRequestTemplate(options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).getBatchUploadEligibilityRequestTemplate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returns paginated data for claim status requests
     * @summary Get paginated data for Claim status requests
     * @param {ClaimStatusRequestQueryModel} claimStatusRequestQueryModel 
     * @param {number} [pgNum] 
     * @param {number} [pgSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public getClaimStatusRequests(claimStatusRequestQueryModel: ClaimStatusRequestQueryModel, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).getClaimStatusRequests(claimStatusRequestQueryModel, pgNum, pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to get the claimstatus request reponse and data
     * @summary Get data for Claim Status Response given ID
     * @param {string} responseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public getClaimStatusResponseByID(responseId: string, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).getClaimStatusResponseByID(responseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get eligibility request data
     * @summary Get paginated data for a Eligibility Requests
     * @param {EligibilityRequestQueryModel} eligibilityRequestQueryModel 
     * @param {number} [pgNum] 
     * @param {number} [pgSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public getEligibilityRequests(eligibilityRequestQueryModel: EligibilityRequestQueryModel, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).getEligibilityRequests(eligibilityRequestQueryModel, pgNum, pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to get the eligibility request status and data
     * @summary Get data for a Eligibility request
     * @param {string} responseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public getEligibilityResponseByID(responseId: string, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).getEligibilityResponseByID(responseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} batchId 
     * @param {BatchUploadEligibilityPatchModel} batchUploadEligibilityPatchModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public patchBatchUploadEligibilityRequest(batchId: string, batchUploadEligibilityPatchModel: BatchUploadEligibilityPatchModel, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).patchBatchUploadEligibilityRequest(batchId, batchUploadEligibilityPatchModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} batchId 
     * @param {{ [key: string]: string; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public patchBatchUploadEligibilityRequestMapping(batchId: string, requestBody: { [key: string]: string; }, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).patchBatchUploadEligibilityRequestMapping(batchId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BatchEligibilityResubmitCreateModel} batchEligibilityResubmitCreateModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public postBatchResubmitEligibilityRequest(batchEligibilityResubmitCreateModel: BatchEligibilityResubmitCreateModel, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).postBatchResubmitEligibilityRequest(batchEligibilityResubmitCreateModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {File} file 
     * @param {BatchUploadEligibilityModel} uploadModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public postBatchUploadEligibilityRequest(file: File, uploadModel: BatchUploadEligibilityModel, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).postBatchUploadEligibilityRequest(file, uploadModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get patient info - check in insurancecoverage if payer, beneficiary, memberId relation exists if it exists then validate data, update patient record and make claim status check request else validate data, create patient record, create insurancecoverage record and make claim status check request
     * @summary post claim status requests
     * @param {Array<ClaimStatusRequest>} claimStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public postClaimStatusRequests(claimStatusRequest: Array<ClaimStatusRequest>, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).postClaimStatusRequests(claimStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get patient info - check in insurancecoverage if payer, beneficiary, memberId relation exists if it exists:     validate data, update patient record and make eligibility request else:     validate data, create patient record, create insurancecoverage record and make eligibility request
     * @summary post eligibility requests
     * @param {Array<EligibilityRequest>} eligibilityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public postEligibilityRequests(eligibilityRequest: Array<EligibilityRequest>, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).postEligibilityRequests(eligibilityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BatchEligibilityResubmitQueryModel} batchEligibilityResubmitQueryModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public validateBatchResubmitEligibilityRequest(batchEligibilityResubmitQueryModel: BatchEligibilityResubmitQueryModel, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).validateBatchResubmitEligibilityRequest(batchEligibilityResubmitQueryModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} batchId 
     * @param {BatchUploadEligibilityPatchModel} batchUploadEligibilityPatchModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public validatePatchBatchUploadEligibilityRequest(batchId: string, batchUploadEligibilityPatchModel: BatchUploadEligibilityPatchModel, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).validatePatchBatchUploadEligibilityRequest(batchId, batchUploadEligibilityPatchModel, options).then((request) => request(this.axios, this.basePath));
    }
}

